// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-container {
    display: flex;
    gap: 12px;
    animation: fade-in 0.3s ease-out;
}

.message-container.user-message {
    justify-content: flex-end;
}

.message-container.ai-message {
    justify-content: flex-start;
}

.message-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-top: 4px;
}

.ai-avatar {
    background: rgba(59, 130, 246, 0.1);
}

.ai-avatar svg {
    width: 16px;
    height: 16px;
    color: #3B82F6;
}

.user-avatar {
    background: #3B82F6;
}

.user-avatar svg {
    width: 16px;
    height: 16px;
    color: white;
}

.message-bubble {
    max-width: 256px;
    padding: 12px 16px;
    border-radius: 16px;
    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.1);
    position: relative;
}

.user-bubble {
    background: #3B82F6;
    color: white;
    border-bottom-right-radius: 6px;
}

.ai-bubble {
    background: #f3f4f6;
    color: #1f2937;
    border-bottom-left-radius: 6px;
}

.message-text {
    font-size: 14px;
    line-height: 1.5;
    white-space: pre-wrap;
    margin: 0 0 4px 0;
}

.message-time {
    font-size: 12px;
    opacity: 0.6;
}

.user-time {
    text-align: right;
}

.ai-time {
    text-align: left;
}

@keyframes fade-in {
    0% {
        opacity: 0;
        transform: scale(0.95);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}

@media (max-width: 768px) {
    .message-bubble {
        max-width: 200px;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/MessageBubble.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":[".message-container {\r\n    display: flex;\r\n    gap: 12px;\r\n    animation: fade-in 0.3s ease-out;\r\n}\r\n\r\n.message-container.user-message {\r\n    justify-content: flex-end;\r\n}\r\n\r\n.message-container.ai-message {\r\n    justify-content: flex-start;\r\n}\r\n\r\n.message-avatar {\r\n    width: 32px;\r\n    height: 32px;\r\n    border-radius: 50%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n    margin-top: 4px;\r\n}\r\n\r\n.ai-avatar {\r\n    background: rgba(59, 130, 246, 0.1);\r\n}\r\n\r\n.ai-avatar svg {\r\n    width: 16px;\r\n    height: 16px;\r\n    color: #3B82F6;\r\n}\r\n\r\n.user-avatar {\r\n    background: #3B82F6;\r\n}\r\n\r\n.user-avatar svg {\r\n    width: 16px;\r\n    height: 16px;\r\n    color: white;\r\n}\r\n\r\n.message-bubble {\r\n    max-width: 256px;\r\n    padding: 12px 16px;\r\n    border-radius: 16px;\r\n    box-shadow: 0 2px 8px -2px rgba(0, 0, 0, 0.1);\r\n    position: relative;\r\n}\r\n\r\n.user-bubble {\r\n    background: #3B82F6;\r\n    color: white;\r\n    border-bottom-right-radius: 6px;\r\n}\r\n\r\n.ai-bubble {\r\n    background: #f3f4f6;\r\n    color: #1f2937;\r\n    border-bottom-left-radius: 6px;\r\n}\r\n\r\n.message-text {\r\n    font-size: 14px;\r\n    line-height: 1.5;\r\n    white-space: pre-wrap;\r\n    margin: 0 0 4px 0;\r\n}\r\n\r\n.message-time {\r\n    font-size: 12px;\r\n    opacity: 0.6;\r\n}\r\n\r\n.user-time {\r\n    text-align: right;\r\n}\r\n\r\n.ai-time {\r\n    text-align: left;\r\n}\r\n\r\n@keyframes fade-in {\r\n    0% {\r\n        opacity: 0;\r\n        transform: scale(0.95);\r\n    }\r\n    100% {\r\n        opacity: 1;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n    .message-bubble {\r\n        max-width: 200px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
